import { getItemById } from '../../content/items/items';
import { useGameStore } from '../../store/gameStore';
import { selectModeType, selectPlayer } from '../../store/selectors';

/** Compact inventory — combat free-actions + out-of-combat save crystal. */
export function InventoryPanel({ compact = false }: { compact?: boolean }) {
  const player = useGameStore(selectPlayer);
  const mode = useGameStore(selectModeType);
  const useItem = useGameStore((state) => state.useItem);
  const inCombat = mode === 'combat';

  if (player.inventory.length === 0) {
    return compact ? null : (
      <section className="inventory-panel">
        <small>HÀNH TRANG</small>
        <p className="inventory-empty">Trống</p>
      </section>
    );
  }

  return (
    <section className={`inventory-panel${compact ? ' is-compact' : ''}`}>
      <small>HÀNH TRANG</small>
      <div className="inventory-list">
        {player.inventory.map((stack) => {
          const def = getItemById(stack.itemId);
          if (!def) {
            return null;
          }
          const canUse = inCombat ? def.usableInCombat : def.usableOutOfCombat;

          return (
            <button
              key={stack.itemId}
              type="button"
              className="inventory-item"
              disabled={!canUse || !player.alive}
              title={def.description}
              onClick={() => useItem(stack.itemId)}
            >
              <strong>
                {def.name} ×{stack.quantity}
              </strong>
              <small>{def.description}</small>
            </button>
          );
        })}
      </div>
    </section>
  );
}
